import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

import { addressFormFields } from './addressFieldsForm';

const formFields = [
  {
    name: 'firstName',
    label: 'First Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'middleName',
    label: 'Middle Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'lastName',
    label: 'Last Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'email',
    label: 'Email',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'phone',
    label: 'Phone',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'companyName',
    label: 'Company Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  ...addressFormFields,
];

export const sellerForm = {
  name: FormNames.SELLER,
  label: 'Seller',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
